import React from 'react'
import styled from '@emotion/styled'

const FormWrapper = styled.div`
  padding: 3rem;
  form {
    > div {
      padding: 0 0 2rem;
    }
    label {
      span {
        font-size: 1.4rem;
        color: ${props => props.theme.colors.blackBlue}
      }
    }
    input[type="text"], input[type="email"], input[type="tel"] {
      width: 30rem;
      border: .1rem solid ${props => props.theme.colors.mediumGrey};
      @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 100%;
      }
    }
    input.hs-button.primary.large {
      font-size: 1.6rem;
      height: 4.5rem;
      padding: 0 2rem;
      line-height: 4.5rem;
      margin: 3rem auto 0;
      display: block;
      background: ${props => props.theme.colors.greyDarkblue};
      border-radius: 3rem;
      border: none;
      color: white;
      outline: 0!important;
      cursor: pointer;
      font-weight: 700;
      transition: background-color 0.2s ease-out;

      &:hover {
        background: ${props => props.theme.colors.blackBlue};
      }
    }

    ul.hs-error-msgs {
      position: absolute;
      margin: 0;
      padding: 0;
      li {
        list-style-type: none;
        font-size: 1.3rem;
        color: #ff0000;
      }
    }

    .field {
      max-width: 30rem
    }

    select {
      margin-top: 1rem;
      width: 100%;
      border: .1rem solid ${props => props.theme.colors.mediumGrey};
    }
  }
`;

export default class extends React.Component {

  constructor() {
    super();
    this.forms = {
      call: '4da584ce-c68f-476d-be93-8c2fabcb8f22',
      hangout: '76dd376a-862e-465a-9f16-97acc23eca1a',
      contactForm: '34471687-3a3f-44cc-98de-199aa14ab6f6',
      simpleContact: 'c54041b2-9822-447c-b7bd-4ec710a0ebd4',
      indexFooterForm: '6f995640-bbd2-444f-a0cb-998ff092c26b',
      downloadOfferForm: 'd8c8ce42-63fb-400c-a05a-bf855a7b29d6',
      newsletterOfferForm: 'bdc79c42-6bfb-4bc2-98bb-88fc04a5268d',
      caseStudyForm: '47a45f9b-266c-488d-91a8-1d6b26833f55',
      tradeActivationForm: 'b85825b0-960a-4248-bed7-613d1b7565dd'
    }
  }

  componentDidMount() {
    const { id } = this.props;
    if (window.hbspt) {
      window.hbspt.forms.create({
        portalId: "3068734",
        formId: this.forms[id],
        target: "#hubspotForm"
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <FormWrapper>
          <div id="hubspotForm"></div>
        </FormWrapper>
      </React.Fragment>
    )
  }
}